export default "__VITE_ASSET__Dwm0Iqjf__"